import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'qvs-spinner-centered',
  templateUrl: './spinner-centered.component.html',
  styleUrls: ['./spinner-centered.component.scss'],
  standalone: true,
  imports: [IonicModule]
})
export class SpinnerCenteredComponent {}
